import React, { useEffect, useState } from 'react'
import { useLoaderData, useSearchParams } from 'react-router'
import { useInfo } from '../context/useInfo';
import LoadingPage from '../components/LoadingPage';
import SmallArticleItem from '../components/SmallArticleItem';

function Searching() {
    const { fetchWeb } = useInfo()
    const [params, setParams] = useSearchParams()
    const { articles } = useLoaderData<{ articles: Record<string, any>[] }>();

    if (articles == undefined) return <LoadingPage />

    return <>
        <div>
            <img src="/images/computer.png" alt="computer icon" className='inline w-16 aspect-square mr-4' />
            <h2 className='inline text-3xl font-semibold mb-2 align-middle'>Search</h2>
        </div>
        {
            articles.map(article => <SmallArticleItem article={article} key={article["article_id"]} />)
        }
    </>
}

export default Searching